export default "__VITE_ASSET__$7UL7iOi__"